import { useCursorActionsContext } from "commons/context/cursor";

import useBaseFetch from "commons/commons-fetch/hooks/useFetch";

function useFetch() {
    const { showCursor, hideCursor } = useCursorActionsContext();

    return useBaseFetch({ onStartCall: showCursor, onEndCall: hideCursor });
}

export default useFetch;
